import { render, staticRenderFns } from "./PaysystemIcon.vue?vue&type=template&id=39c75702&"
import script from "./PaysystemIcon.vue?vue&type=script&lang=js&"
export * from "./PaysystemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports